import Carousel from 'react-material-ui-carousel'
export { Carousel }
